/**
 * OnboardingApprovalViewer Parent Component
 * This component serves as the main container and can have child components inside "components/" folder.
 */
import React from "react";
import styles from "./OnboardingApprovalViewer.module.css";
import { useState, useEffect } from "react";
import { ThreeCircles } from "react-loader-spinner";
import { OnboardingApprovalViewerProps } from "./OnboardingApprovalViewer.utils";
import CygnusForm from "../../../../../Reusables/components/CygnusForm/CygnusForm";
import { FieldProps } from "../../../../../Reusables/components/InputFieldsController/InputFieldsController.utils";

/**
 * Full-screen modal for previewing forms before submission.
 */
export const OnboardingApprovalViewer: React.FC<
  OnboardingApprovalViewerProps
> = ({ sharedData, setSharedData, onValidationChange, onFormLoaded  }) => {
  // State variables
  const [clientFormFields, setClientFormFields] = useState<FieldProps[]>(
    sharedData.onboardingFormData
  );
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (sharedData.onboardingFormData.length === 0) {
      setLoading(true);
    } else {
      setClientFormFields(sharedData.onboardingFormData);
      
      // Check if there are any fields with API dropdowns
      const hasApiDropdowns = sharedData.onboardingFormData.some(
        (field) => field.apiConfig?.apiKey
      );
      
      // If no API dropdowns, set loading to false immediately
      if (!hasApiDropdowns) {
        setLoading(false);
        // Notify parent immediately if no dropdowns to load
        onFormLoaded?.('onboarding');
      }
    }
  }, [sharedData.onboardingFormData, onFormLoaded]);

  const handleDropdownsLoaded = () => {
    setLoading(false);
    // Notify parent that this form is fully loaded
    onFormLoaded?.('onboarding');
  };

  return (
    <>
      {loading && (
        <div className={styles.loaderWrapper}>
          <div className={styles.approvalLoader}>
            <div className="flex-row-center-center" style={{ marginLeft: 5 }}>
              <div style={{ width: "fit-content", padding: 0 }}>
                <ThreeCircles
                  height="35"
                  width="35"
                  color="#4fa94d"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                  ariaLabel="three-circles-rotating"
                  outerCircleColor="var(--theme1_tertiary)"
                  innerCircleColor="var(--theme1_secondary)"
                  middleCircleColor="var(--theme1_primary)"
                />
              </div>
              <h6 style={{ width: "fit-content", marginLeft: 10 }}>
                Loading your details
              </h6>
            </div>
          </div>
        </div>
      )}
      
        <CygnusForm
          formId="cygnus-client-approval-form"
          fields={clientFormFields}
          onFieldsChange={setClientFormFields}
          onValidationChange={() => {
            // NOT REQUIRED HERE
          }}
          onDropdownsLoaded={handleDropdownsLoaded}
          fieldVariant={sharedData.onboardingFieldVariant}
          sectionVariant={sharedData.onboardingSectionVariant}
          sectionLayout={sharedData.onboardingSectionLayout}
          intakeRules={sharedData.onboardingIntakeRules}
        />
    </>
  );
};

export default OnboardingApprovalViewer;